export default __webpack_public_path__ + "static/media/back.cde0cde0.jpg";